import {Receipt} from '@mui/icons-material'
import i18n from 'i18next';

const getAIPackages = () => ({
  id: 'aiPackages',
  type: 'group',
  children: [
    {
      id: 'aiPackages',
      title: i18n.t('sidemenu.aiPackagesManagement'),
      type: 'item',
      url: '/aiPackages',
      icon: Receipt,
      breadcrumbs: false,
    },
  ]
});

export default getAIPackages;